<template>
  <div v-if="filterOptions && Object.keys(filterOptions).length" class="cl__tf">
    <div
      v-for="(count,name) in filterOptions" :key="name"
      :class="['cl__tf-item',{'checked':checkedOptions.some(option => isEqual(option, name))}]"
    >
    <input 
      class="cl__tf-checkbox"
      type="checkbox" 
      :value="name" 
      :id="name"
      :checked="checkedOptions.some(option => isEqual(option, name))"
      @change="e => updateCheckedInput(e,'benefit',name)"
    />
    <label class="cl__tf-label text-lg mobile-text-base"> {{name}}</label>
    </div>
  </div>
</template>

<script setup>
  import {ref, toRefs, watch} from 'vue';
  import isEqual from 'lodash/isEqual';

  const props = defineProps({
    filterOptions: {
      type: Object,
      required: true,
    },

    appliedFilters: {
      type: Object,
      required: true,
    }
  })

  const { filterOptions, appliedFilters } = toRefs(props)

  const emit = defineEmits(['onFilterChange']) 
  const checkedOptions = ref([])

  const updateCheckedInput = (event,type,option) => {
    if (event.target.checked) {
      checkedOptions.value = [...checkedOptions.value, option]
    }else {
      checkedOptions.value = checkedOptions.value.filter(
        checkedOption => !isEqual(checkedOption, option)
      )
    }

    emit('onFilterChange',type,checkedOptions.value)
  }

  watch(appliedFilters, (value) => {
    const newCheckedOptions = value || []

    if (!isEqual(checkedOptions.value, newCheckedOptions)) {
      checkedOptions.value = newCheckedOptions
    }
  })
</script>